import { FeatureTogglesInput } from "../../inputs/FeatureTogglesInput";
import { FormCard } from "../../misc/FormCard";

export function StudentAdminForm() {
  return (
    <FormCard title="Feature Toggles">
      <FeatureTogglesInput />
    </FormCard>
  );
}
